// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"230":"a6e0b644","234":"a6e0b644","575":"a6e0b644","849":"31d6cfe0","872":"a6e0b644","956":"a6e0b644"}[chunkId] + ".css";
};